import { useCallback, useEffect, useRef, useState } from 'react';

export const useHandleTabChange = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabLinksContainer = useRef<HTMLDivElement>(null);
  const activeTabBorder = useRef<HTMLDivElement>(null);

  // Logic for animating the active border
  const TabLinkButtons = useRef<HTMLButtonElement[]>([]);

  const populateTabLinkButtons = () => {
    const tabLinks: HTMLButtonElement[] = Array.from(
      tabLinksContainer.current?.querySelectorAll('button') || []
    );
    TabLinkButtons.current = tabLinks;
  };

  const animateActiveTabBorder = useCallback((idx: number) => {
    // Grab the tab links button if it's the first time running this function
    if (!TabLinkButtons.current.length || !TabLinkButtons.current[0].isConnected)
      populateTabLinkButtons();

    const tabLinks: HTMLButtonElement[] = TabLinkButtons.current;

    if (activeTabBorder.current && tabLinks.length && tabLinks[idx]) {
      const { width } = tabLinks[idx].getBoundingClientRect();
      activeTabBorder.current.style.transform = `translateX(${tabLinks[idx].offsetLeft}px)`;
      activeTabBorder.current.style.width = `${width}px`;
    }
  }, []);

  useEffect(() => {
    const recalculateActiveBorder = () => {
      animateActiveTabBorder(activeTab);
    };
    recalculateActiveBorder();
    window.addEventListener('resize', recalculateActiveBorder);

    return () => {
      window.removeEventListener('resize', recalculateActiveBorder);
    };
  }, [activeTab, animateActiveTabBorder]);

  return {
    activeTab,
    tabLinksContainer,
    activeTabBorder,
    setActiveTab
  };
};
